import {
	AuthenticatedTemplate,
	MsalProvider,
	UnauthenticatedTemplate,
	useMsal,
} from "@azure/msal-react";
import { useSelector } from "react-redux";
import { Toaster } from "sonner";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import { Editor } from "./features/editor/Editor";
import { redo, undo } from "./features/editor/editorSlice";
import {
	fetchLogicsCommits,
	selectFetchBackendStatus,
} from "./features/logics/logicsSlice";
import { MenuManager } from "./features/menuManager/MenuManager";
import { WindowManager } from "./features/windowManager/WindowManager";
import { LoadingApp } from "./pages/LoadingApp/LoadingApp";

import { IPublicClientApplication } from "@azure/msal-browser";
import { useEffect } from "react";
import "./App.css";
import {
	selectOpenSearch,
	setOpenSearch,
} from "./features/windowManager/windowManagerSlice";
import { Login } from "./pages/Login/Login";

export interface AppProps {
	instance: IPublicClientApplication;
}

export const appMainElementId = "app-main-element";

const MainContent = () => {
	const dispatch = useAppDispatch();
	const openSearch = useAppSelector(selectOpenSearch);
	const reflistStatus = useSelector(selectFetchBackendStatus);

	if (reflistStatus.code === "idle") {
		dispatch(fetchLogicsCommits());
	}
	const { instance } = useMsal();
	const activeAccount = instance.getActiveAccount();

	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			if (
				(event.ctrlKey || event.metaKey) &&
				!event.shiftKey &&
				event.key.toLowerCase() === "z"
			) {
				event.preventDefault();
				dispatch(undo());
			}

			if (
				(event.ctrlKey || event.metaKey) &&
				event.shiftKey &&
				event.key.toLowerCase() === "z"
			) {
				event.preventDefault();
				dispatch(redo());
			}

			if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "y") {
				event.preventDefault();
				dispatch(redo());
			}

			if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "f") {
				event.preventDefault();
				dispatch(setOpenSearch(!openSearch));
			}
		};

		window.addEventListener("keydown", handleKeyDown);

		return () => {
			window.removeEventListener("keydown", handleKeyDown);
		};
	}, [openSearch]);

	return (
		<div className="App">
			<AuthenticatedTemplate>
				{activeAccount ? (
					<div className="App" id={appMainElementId}>
						<Toaster
							closeButton
							position="top-right"
							expand
							richColors
							duration={10000}
							toastOptions={{
								style: {
									width: "fit-content",
									whiteSpace: "nowrap",
								},
							}}
						/>
						{(reflistStatus.code === "loading" ||
							reflistStatus.code === "failed") && (
							<>
								<LoadingApp />
							</>
						)}
						{reflistStatus.code === "succeeded" && (
							<>
								<Editor />
								<WindowManager />
								<MenuManager />
							</>
						)}
					</div>
				) : null}
			</AuthenticatedTemplate>
			<UnauthenticatedTemplate>
				<Login />
			</UnauthenticatedTemplate>
		</div>
	);
};

function App({ instance }: AppProps) {
	return (
		<MsalProvider instance={instance}>
			<MainContent />
		</MsalProvider>
	);
}

export default App;
